import { useLayoutEffect, useRef, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { TokenFilterSection } from './TokenFilter';
import {
  SelectWalletBox,
  SelectSessionButton,
  SelectAddressFromKeypoolButton,
} from './KeysAndSigningUI';
import { TextLine3 } from './UtilComponents';
import {
  useGlobalStateSelector,
  words,
  stateKeysToSetAddress,
  stateKeysToSetUserName,
  marginOfSessionTime,
} from './globalState';
import {
  handleClickMpurse,
} from './keysAndSigning';
import {
  reload,
  reloadGallery,
  handleClickPopupUserRegistration,
  handleClickPopupLogin,
  handleClickAddressHistory,
} from './monacottoMisc';
import {
  devLog,
  localTime,
} from './utils';
import iconReload from './refresh_black_24dp.svg';
import iconZero from './counter_0_FILL0_wght400_GRAD0_opsz48.svg';
import iconHome from './home_FILL0_wght400_GRAD0_opsz48.svg';
import iconLogin from './login_black_24dp.svg';
import iconLeftBlack from './baseline_arrow_left_black_18dp.png';
import iconRightBlack from './baseline_arrow_right_black_18dp.png';
import iconAddress from './slab_serif_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconList from './format_list_bulleted_FILL0_wght400_GRAD0_opsz48.svg';
import logoMonacotto from './logoMonacotto.png';
import iconExpand from './expand_all_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconCollapse from './collapse_all_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconLock from './lock_FILL0_wght400_GRAD0_opsz48.svg';
import iconCircleLeft from './arrow_circle_left_FILL0_wght400_GRAD0_opsz48.svg';
import iconCircleRight from './arrow_circle_right_FILL0_wght400_GRAD0_opsz48.svg';

// HEADER
function Header(props){
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );
  const screen = props.screen;
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined ? popupLayer + 1 : 0;
  const headerAdditional = props.headerAdditional;
  const headerClass = props.headerClass !== undefined && props.headerClass !== null ? props.headerClass : '';
  const noteInfo = props.noteInfo;
  const heightObservation = props.heightObservation;

  const headerRef = useRef(null);

  useLayoutEffect(() => {
    if (heightObservation !== true) return;

    // クリーンアップ用に、現在の参照をローカル変数にコピー
    const currentHeader = headerRef.current;

    // 高さを同期する関数
    const syncHeight = () => {
      // const headerNewest = headerRef.current;

      if (currentHeader) {
        dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'headerHeight'], value: currentHeader.offsetHeight });
      }
    }

    // 初回同期
    syncHeight();

    // ウィンドウリサイズ時にも同期
    window.addEventListener('resize', syncHeight);

    // ResizeObserverでノートヘッダのサイズ変更を監視
    let headerObserver;

    if ('ResizeObserver' in window && currentHeader) {
      headerObserver = new ResizeObserver(syncHeight);
      headerObserver.observe(currentHeader);
    }

    // クリーンアップ
    return () => {
      window.removeEventListener('resize', syncHeight);

      if (headerObserver && currentHeader) {
        // headerObserver.disconnect();
        headerObserver.unobserve(currentHeader);
      }
    };
  }, []);

  // リロードボタン
  let reloadButton;

  if (screen === 'newCard' || screen === 'village' || screen === 'allCard') {
    let searchItemType;
    let setItemKey;

    if (screen === 'newCard') {
      searchItemType = 'new';
      setItemKey = 'itemsNew';
    }
    else if (screen === 'village') {
      searchItemType = 'new';
      setItemKey = 'itemsNew';
    }
    else { // allCard
      searchItemType = 'all';
      setItemKey = 'itemsAll';
    }

    reloadButton =
    <button className='button1' onClick={ () => reload(state, dispatch, 'all', searchItemType, setItemKey) } >
      <img className='size2x2' src={iconReload} alt='' />
    </button>;
  }
  else if (screen === 'gallery') {
    reloadButton =
    <button className='button1' onClick={ () => reloadGallery(state, dispatch) } >
      <img className='size2x2' src={iconReload} alt='' />
    </button>;
  }
  else {
    reloadButton = null;
  }

  // フィルタボタン

  let balanceFilter;

  if (screen === 'newCard' || screen === 'gallery' || screen === 'allCard') {
    balanceFilter =
    <button className={'button1' + (state.balanceFilter === true ? ' backgroundColorMonacottoPale' : '')} onClick={ () => dispatch({ type: 'setState', key: 'balanceFilter', value: !state.balanceFilter }) }
    >
      <img className='size2x2' src={iconZero} alt='' />
    </button>;
  }
  else {
    balanceFilter = null;
  }

  // マイホームボタン

  let myHomeButton;

  if (screen !== 'gallery') {
    if (state.active.addressMain !== undefined && state.active.addressMain !== null && state.active.addressMain !== '') { 
      const userActive = state.usersGeneral.find( user => user.addressMain === state.active.addressMain );

      if (userActive?.homed === true) {
        myHomeButton =
        <button className='button1'
          onClick={ () =>{
            dispatch({ type: 'setStateMultiLayers', keys: ['gallery', 'addressMain'], value: userActive.addressMain });
            navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/home' : '/home'); 
          }}
        >
          <img className='size2x2' src={iconHome} alt='' />
        </button>;
      }
    }
  }

  // 固定通知

  // eslint-disable-next-line no-unused-vars
  let fixedWordNotification =
  <div>
    5/2に利用規約の変更を行いました。設定画面でログインし、規約を確認・同意のうえ、署名・登録を行ってください。
  </div>;
  /*
      <div>
        ただいまお試しサービス期間につき、出品・購入は申込みが必要になります。利用を希望される方は、以下よりお申し込みください。
      </div>
      <button className={'borderNone backgroundColorTransparent marginTop0p5 focusEffect01 cursor'} tabindex='0'
        onClick={ () => window.open('https://spotlight.soy/detail?article_id=v2ao93jto') }
      >
        {'https://spotlight.soy/detail?article_id=v2ao93jto'}
      </button>
  */


  return (
    <div className='' >
      {/* PC */}
      <div ref={headerRef} className={'invisibleSp backgroundColorWhiteTransparent width99vw ' + headerClass}>
        <div className='flexColumn'>
          <div className='flexRow justifyContentSpaceBetween' >
            {/* logo */}
            <div className='flexRow'>
              <button className='borderNone backgroundColorTransparent cursor '
                onClick={ () => {
                  devLog(screen);
                  if (screen !== 'village') {
                    navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/newcard' : '/newcard');
                  }
                }}
              >
                <img className='width24 ' src={logoMonacotto} alt='' />
              </button>
              <div>
                { process.env.REACT_APP_ENVIRONMENT === 'dev' ? 'dev' : null }
              </div>
              {/* cotto-chan */}
              <button className='borderNone backgroundColorTransparent cursor marginTop1'
                onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['notification', 'fixed'], value: !state.notification.fixed }) }
              >
                <div className={ state.accessing ? 'cottoRolling' : 'cottoStill' } />
              </button>
              {/* notification */}
              { state.notification.fixed ? <Notification /> : <NotificationFadingOut /> }
            </div>
            <div className='flexColumn'>
              {/* language */}
              <div className='flexRow justifyContentFlexEnd marginSide0p5'>
                <button className={'borderNone backgroundColorWhite focusEffect01 borderRadius2 riseOut2 marginSide0p2 ' + (state.language === 'english' ? 'colorRed' : 'cursor')} tabindex='0'
                  onClick={ () => {
                            dispatch({type: 'setState', key: 'language', value: 'english'});
                  }}>
                  english
                </button>
                <button className={'borderNone backgroundColorWhite focusEffect01 borderRadius2 riseOut2 marginSide0p2 ' + (state.language === 'japanese' ? 'colorRed' : 'cursor')} tabindex='0'
                  onClick={ () => {
                            dispatch({type: 'setState', key: 'language', value: 'japanese'});
                  }}>
                  japanese
                </button>
              </div>
              <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop0p5'>
                <SelectWalletBox keypoolButtonVisible={true} fullWidth={false} />
                <SelectSessionButton popupLayer={popupLayer} loginEnabled={true} setConfigure={true} />
                <SelectAddressFromKeypoolButton
                  popupLayer={popupLayer}
                  stateKeysToSetAddress={stateKeysToSetAddress}
                  stateKeysToSetUserName={stateKeysToSetUserName}
                  loginEnabled={true}
                  setConfigure={true}
                  subAddressEnabled={true}
                />
                { myHomeButton }
                {/* user registration */}
                <button className='buttonMainColor widthMin12 height3 ' tabindex='0'
                  onClick={ () => {
                    handleClickPopupUserRegistration(state, dispatch);
                  }}
                >
                  <div>
                    { words.userRegistration[state.language] }
                  </div>
                </button>
                {/* login */}
                <button className='buttonMainColor widthMin12 height3 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
                  onClick={ () => {
                    handleClickPopupLogin(state, dispatch, null, { noteInfo });
                  }}
                >
                  <div>
                    { words.login[state.language] }
                  </div>
                  <img className='size2x2' src={iconLogin} alt='' />
                </button>
              </div>
            </div>
          </div>
          {/* menu */}
          <div className='flexRow justifyContentFlexEnd' >
            <div className='flexRow justifyContentFlexEnd marginTop1 marginSide1'>
              { reloadButton }
              { balanceFilter }
            </div>
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginTop1 marginSide0p2'
              onClick={ () => {
                devLog(screen);
                if (screen !== 'newCard') {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/newcard' : '/newcard');
                }
              }}
            >
              {words.newCard[state.language]}
            </button>
            <TokenFilterSection popupLayerNext={popupLayerNext} screen={screen} margin=' marginTop1 marginSide0p2' />
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginTop1 marginSide0p2'
              onClick={ () => {
                devLog(screen);
                if (screen !== 'village') {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/plaza' : '/plaza');
                }
              }}
            >
              {words.goOut[state.language]}
            </button>
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginTop1 marginSide0p2'
              onClick={ () => {
                if (screen !== 'exhibit') {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/exhibit' : '/exhibit');
                }
              }}
            >
              {words.exhibit[state.language]}
            </button>
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginTop1 marginSide0p2'
              onClick={ () => {
                if (screen !== 'history') {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/history' : '/history');
                }
              }}
            >
              {words.history[state.language]}
            </button>
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginTop1 marginSide0p2'
              onClick={ () => {
                if (screen !== 'permission') {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/permission' : '/permission');
                }
              }}
            >
              {words.permissionAndDelegation[state.language]}
            </button>
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginTop1 marginSide0p2'
              onClick={ () => {
                if (screen !== 'managementScreen') {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/config' : '/config');
                }
              }}
            >
              {words.setUp[state.language]}
            </button>
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginTop1 marginSide0p2' tabindex='0'
              onClick={ () => {
                if (screen !== 'howToUse') {
                  /* window.open('https://spotlight.soy/detail?article_id=p7m455wkd'); */
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtouse' : '/howtouse'); 
                }
              }}
            >
              {words.howToUse[state.language]}
            </button>
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginTop1 marginSide0p2' tabindex='0'
              onClick={ () => {
                window.open(`https://${process.env.REACT_APP_KOM_MAIN_URL}`);
              }}
            >
              {words.monadom[state.language]}
            </button>
          </div>
          { headerAdditional }
        </div>
        {/* popup */}
        {/*
          <Popup layer={0}/>
          <Popup layer={1}/>
        */}
      </div>
      {/* SP */}
      <div className='invisiblePc'>
        <div className='flexColumn alignItemsCenter '>
          <div>
            { process.env.REACT_APP_ENVIRONMENT === 'dev' ? 'dev' : null }
          </div>
          <div className='flexRow justifyContentCenter'>
            {/* logo */}
            <button className='borderNone backgroundColorTransparent cursor width75PC'
              onClick={ () => {
                devLog(screen);
                if (screen !== 'village') {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/newcard' : '/newcard');
                }
              }}
            >
              <img className='widthMax' src={logoMonacotto} alt='' />
            </button>
            {/* cotto-chan */}
            <button className='borderNone backgroundColorTransparent cursor '
              onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['notification', 'fixed'], value: !state.notification.fixed }) }
            >
              <div className={ state.accessing ? 'cottoRolling' : 'cottoStill' } />
            </button>
          </div>
          {/* cotto-chan */}
          <RollingCottochan />
          {/* notification */}
          { state.notification.fixed ? <Notification /> : <NotificationFadingOut /> }
          {/* language */}
          <div className='flexRow justifyContentSpaceAround marginSide0p5'>
            <button className={'borderNone backgroundColorWhite focusEffect01 borderRadius2 riseOut2 marginSide0p2 ' + (state.language === 'english' ? 'colorRed' : 'cursor')} tabindex='0'
              onClick={ () => {
                        dispatch({type: 'setState', key: 'language', value: 'english'});
              }}>
              english
            </button>
            <button className={'borderNone backgroundColorWhite focusEffect01 borderRadius2 riseOut2 marginSide0p2 ' + (state.language === 'japanese' ? 'colorRed' : 'cursor')} tabindex='0'
              onClick={ () => {
                        dispatch({type: 'setState', key: 'language', value: 'japanese'});
              }}>
              japanese
            </button>
          </div>
          <div className='flexRow justifyContentCenter alignItemsCenter marginTop0p5 '>
            {/* user registration */}
            <button className='buttonMainColor widthMin12 height3 ' tabindex='0'
              onClick={ () => {
                handleClickPopupUserRegistration(state, dispatch);
              }}
            >
              <div>
                { words.userRegistration[state.language] }
              </div>
            </button>
            {/* login */}
            <button className='buttonMainColor widthMin12 height3 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
              onClick={ () => {
                handleClickPopupLogin(state, dispatch, null, { noteInfo });
              }}
            >
              <div>
                { words.login[state.language] }
              </div>
              <img className='size2x2' src={iconLogin} alt='' />
            </button>
          </div>
          <SelectWalletBox keypoolButtonVisible={true} fullWidth={true} />
          <div className='flexRow justifyContentCenter alignItemsCenter marginTopBottom0p3 marginSide1'>
            <SelectSessionButton popupLayer={popupLayer} loginEnabled={true} setConfigure={true} />
                <SelectAddressFromKeypoolButton
                  popupLayer={popupLayer}
                  stateKeysToSetAddress={stateKeysToSetAddress}
                  stateKeysToSetUserName={stateKeysToSetUserName}
                  loginEnabled={true}
                  setConfigure={true}
                  subAddressEnabled={true}
                />
            { myHomeButton }
            { balanceFilter }
            { reloadButton }
          </div>
          {/* menu */}
          <div className='flexRow justifyContentSpaceAround marginTopBottom1' >
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 marginTopBottom0p3'
              onClick={ () => {
                devLog(screen);
                if (screen !== 'newCard') {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/newcard' : '/newcard');
                }
              }}
            >
              {words.newCard[state.language]}
            </button>
            <TokenFilterSection popupLayerNext={popupLayerNext} screen={screen} margin=' marginSide0p2 marginTopBottom0p3' />
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 marginTopBottom0p3'
              onClick={ () => {
                devLog(screen);
                if (screen !== 'village') {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/plaza' : '/plaza');
                }
              }}
            >
              {words.goOut[state.language]}
            </button>
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 marginTopBottom0p3'
              onClick={ () => {
                if (screen !== 'exhibit') {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/exhibit' : '/exhibit');
                }
              }}
            >
              {words.exhibit[state.language]}
            </button>
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 marginTopBottom0p3'
              onClick={ () => {
                if (screen !== 'history') {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/history' : '/history');
                }
              }}
            >
              {words.history[state.language]}
            </button>
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 marginTopBottom0p3'
              onClick={ () => {
                if (screen !== 'permission') {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/permission' : '/permission');
                }
              }}
            >
              {words.permissionAndDelegation[state.language]}
            </button>
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 marginTopBottom0p3'
              onClick={ () => {
                if (screen !== 'managementScreen') {
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/config' : '/config');
                }
              }}
            >
              {words.setUp[state.language]}
            </button>
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 marginTopBottom0p3' tabindex='0'
              onClick={ () => {
                if (screen !== 'howToUse') {
                  /* window.open('https://spotlight.soy/detail?article_id=p7m455wkd'); */
                  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/howtouse' : '/howtouse'); 
                }
              }}
            >
              {words.howToUse[state.language]}
            </button>
            <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 marginTopBottom0p3' tabindex='0'
              onClick={ () => {
                window.open(`https://${process.env.REACT_APP_KOM_MAIN_URL}`);
              }}
            >
              {words.monadom[state.language]}
            </button>
          </div>
        </div>
        {/* popup */}
        {/*
          <Popup layer={0}/>
          <Popup layer={1}/>
        */}
      </div>
    </div>
  );
}

// NOTIFICATION
function Notification() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  if (state.notification.fixed === true) {
    return (
      <div>
        {/* PC */}
        <div className='visibleLargeOrMore '>
          <div className='flexRow justifyContentFlexEnd marginSide0p5 marginBottomM0p5'>
            <div className='cursor'
              onClick={ () => {
                if (state.notification.index > 0) {
                  dispatch({ type: 'setStateMultiLayers', keys: ['notification', 'index'], value: state.notification.index - 1 });
                }
              }}
            >
              <img className='size1p7x1p7' src={iconLeftBlack} alt='left' />
            </div>
            <div className='cursor'
              onClick={ () => {
                if (state.notification.index < state.notification.body.length - 1) {
                  dispatch({ type: 'setStateMultiLayers', keys: ['notification', 'index'], value: state.notification.index + 1 });
                }
              }}
            >
              <img className='size1p7x1p7' src={iconRightBlack} alt='right' />
            </div>
          </div>
          <div className='box2 '>
            { state.notification.body[state.notification.index] }
          </div>
        </div>
        {/* SP */}
        <div className='visibleMiddleOrLess flexColumn alignItemsCenter width98vw '>
          <div className='flexRow justifyContentFlexEnd width95vw marginBottomM0p5 '>
            <div className='cursor'
              onClick={ () => {
                if (state.notification.index > 0) {
                  dispatch({ type: 'setStateMultiLayers', keys: ['notification', 'index'], value: state.notification.index - 1 });
                }
              }}
            >
              <img className='size1p7x1p7' src={iconLeftBlack} alt='left' />
            </div>
            <div className='cursor'
              onClick={ () => {
                if (state.notification.index < state.notification.body.length - 1) {
                  dispatch({ type: 'setStateMultiLayers', keys: ['notification', 'index'], value: state.notification.index + 1 });
                }
              }}
            >
              <img className='size1p7x1p7' src={iconRightBlack} alt='right' />
            </div>
          </div>
          <div className='box2Sp '>
            { state.notification.body[state.notification.index] }
          </div>
        </div>
      </div>
    );
  }
  else {
  }
}

// NOTIFICATION FADING OUT
function NotificationFadingOut () {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  useEffect( () => {
    return () => {
      dispatch({ type: 'stopNotificationAnimation', key: 'notification' });
    };
  }, []);

  return (
    <CSSTransition in={state.notification.inAnimation} timeout={5000} classNames="messageFade"
      onEntered={ () => {
                    dispatch({ type: 'stopNotificationAnimation', key: 'notification' });
                  }
               }
    >
      <div className={state.notification.inAnimation ? 'maxWidth98vw' : 'invisible'} >
          { state.notification.body[state.notification.index] }
      </div>
    </CSSTransition>
  );
}

// ROLLING COTTOCHAN
function RollingCottochan () {
  const state = useGlobalStateSelector( ({ state }) => state );

  let cottochan;

  if (state.accessing) {
    cottochan = <div className='cottoRollingCenter' />;
  }
  else {
    cottochan = null;
  }

  return (
    <div>
      { cottochan }
    </div>
  );
}

// ADDRESS IF NOT HIDDEN SECTIONS
// eslint-disable-next-line no-unused-vars
function AddressIfNotHiddenSections(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const keys = props.keys;

  let addressSection;

  if (state.configure.displayAddressSection) {
    addressSection = <AddressSection keys={keys} />;
  }


  return addressSection;
}

// ADDRESS SECTION
function AddressSection(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const keys = props.keys;


  return (
    <div className='flexRow justifyContentCenter alignItemsCenter '>
      <TextLine3 fieldName='addressSectionAddressMain' keys={keys} face={words.addressMain[state.language]} tooltip='right' />
      <button className='button1'
        onClick={ () => handleClickMpurse(state, dispatch, keys) }
      >
        <img className='size2x2' src={iconAddress} alt='' />
      </button>
      {/*
        <button className='button1'
          onClick={ () =>
            handleClickAddressHistory(state, dispatch, cookies, ['login', 'addressMain'], popupLayer)
          }
        >
          <img className='size2x2' src={iconLoginList} alt='' />
        </button>
      */}
    </div>
  );
}

// ADDRESS HISTORY IF NOT HIDDEN SECTIONS
// eslint-disable-next-line no-unused-vars
function AddressHistoryIfNotHiddenSections(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const keys = props.keys;

  let addressHistorySection;

  if (state.configure.displayAddressSection) {
    addressHistorySection =
    <button className='button1' onClick={ () => handleClickAddressHistory(state, dispatch, cookies, keys) }>
      <img className='size2x2' src={iconList}  alt='' />
    </button>;
  }


  return addressHistorySection;
}

// ADDRESS HISTORY POPUP
function AddressHistoryPopup(props) {
  const popupLayer = props.popupLayer;
  const state = useGlobalStateSelector( ({ state }) => state );
  const body = state.popup[popupLayer].body;
  const options = body.addressHistory.map( record => <AddressHistoryRecord record={record} stateKeys={body.stateKeys} layer={popupLayer} /> );

  return (
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsCenter'>
        <div className='flexColumn alignItemsCenter'>
          <AddressHistoryTitle />
        </div>
        <div className='flexColumn alignItemsCenter'>
          { options }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess flexColumn widthMax'>
        <div className='flexColumn alignItemsCenter widthMax'>
          <AddressHistoryTitle />
        </div>
        <div className='flexColumn alignItemsCenter widthMax'>
          { options }
        </div>
      </div>
    </div>
  );
}

// ADDRESS HISTORY TITLE
function AddressHistoryTitle(props) {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div className='widthMax'>
      {/* PC */}
      <div className='visibleMiddleOrMore boxMonacotto1 margin0p5' >
        <div className='marginSide1 widthMin25' >
          { words.address[state.language] }
        </div>
        <div className='marginSide1 widthMin20' >
          { words.action[state.language] }
        </div>
        <div className='marginSide1 widthMin15' >
          { words.addressType[state.language] }
        </div>
        <div className='marginSide1 widthMin25' >
          { words.description[state.language] }
        </div>
        <div className='marginSide1 widthMin10' >
          { words.dateAndTime[state.language] }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess boxMonacotto1SmallScreen ' >
        <div className='' >
          { words.address[state.language] }
        </div>
        <div className='' >
          { words.action[state.language] }
        </div>
        <div className='' >
          { words.addressType[state.language] }
        </div>
        <div className='' >
          { words.description[state.language] }
        </div>
        <div className='' >
          { words.dateAndTime[state.language] }
        </div>
      </div>
    </div>
  );
}

// ADDRESS HISTORY RECORD
function AddressHistoryRecord(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const record = props.record;
  const stateKeys = props.stateKeys;
  const layer = props.layer;

  return (
    <div className=''>
      {/* PC */}
      <button className='visibleMiddleOrMore boxMonacotto1 margin0p5 cursor riseOut2'
        onClick={ () => {
          dispatch({ type: 'setStateMultiLayers', keys: stateKeys, value: record.address });
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', layer], value: { type: null, body: null } });
        }} 
      >
        <div className='marginSide1 widthMin25' >
          { record.address }
        </div>
        <div className='marginSide1 widthMin20' >
          { words[record.action][state.language] }
        </div>
        <div className='marginSide1 widthMin15' >
          { words[record.addressType][state.language] }
        </div>
        <div className='marginSide1 widthMin25' >
          { record.description }
        </div>
        <div className='marginSide1 widthMin10' >
          { localTime(record.time, 'yearToMinute') }
        </div>
      </button>
      {/* SP */}
      <button className='visibleSmallOrLess boxMonacotto1SmallScreen cursor riseOut2'
        onClick={ () => {
          dispatch({ type: 'setStateMultiLayers', keys: stateKeys, value: record.address });
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', layer], value: { type: null, body: null } });
        }} 
      >
        <div className='breakAll' >
          { record.address }
        </div>
        <div className='' >
          { words[record.action][state.language] }
        </div>
        <div className='' >
          { words[record.addressType][state.language] }
        </div>
        <div className='' >
          { record.description }
        </div>
        <div className='' >
          { localTime(record.time, 'yearToMinute') }
        </div>
      </button>
    </div>
  );
}

// USER NAME
function UserName(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const keys = props.keys;


  return (
    <TextLine3 fieldName='userName' keys={keys} face={words.userName[state.language]} tooltip='right' />
  );
}

// SWITCH ICON
// eslint-disable-next-line no-unused-vars
function SwitchIcon() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  let switchIcon;

  if (state.configure.displayAddressSection) {
    switchIcon = iconCollapse;
  }
  else {
    switchIcon = iconExpand;
  }


  return (
    <button className={'button1'} tabindex='0'
      onClick={ () => {
        dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'displayAddressSection'], value: state.configure.displayAddressSection ? false : true });
      }}
    >
      <img className='size2x2' src={switchIcon} alt='' />
    </button>
  );
}

// FOR DEVELOPMENT
function ForDevelopment() {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div className='invisibleSp' >
        <hr/>
        <div className='widthVW'>
          exhibitHistory: {JSON.stringify(state.exhibitHistory)}<br/>
          session: {JSON.stringify(state.session)}<br/>
          user: {JSON.stringify(state.user)}<br/>
          usersGeneral: {JSON.stringify(state.usersGeneral)}<br/>
          configure: {JSON.stringify(state.configure)}<br/>
          assetInfo: {JSON.stringify(state.assetInfo)}<br/>
          monacard: {JSON.stringify(state.monacard)}<br/>
          purchase: {JSON.stringify(state.purchase)}<br/>
          popup: {JSON.stringify(state.popup)}<br/>
          getPermissionHistory: {JSON.stringify(state.getPermissionHistory)}<br/>
          changeExhibit: {JSON.stringify(state.changeExhibit)}<br/>
        </div>
    </div>
  );
}

// FOOTER
function Footer() {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div className='footer'>
      <button className={'borderNone backgroundColorTransparent marginSide1 focusEffect01 cursor'} tabindex='0'
        onClick={ () => window.open('https://' + process.env.REACT_APP_ABOUT_US) }
      >
        {words.aboutUs[state.language]}
      </button>
      <button className={'borderNone backgroundColorTransparent marginSide1 focusEffect01 cursor'} tabindex='0'
        onClick={ () => {
          window.open('https://' + process.env.REACT_APP_MONACOTTO_NOTATION_BASED_ON_THE_ACT_ON_SPECIFIED_COMMERCIAL_TRANSACTIONS);
        } }>
        {words.notationBasedOnTheActOnSpecifiedCommercialTransactions[state.language]}
      </button>
      <button className={'borderNone backgroundColorTransparent marginSide1 focusEffect01 cursor'} tabindex='0'
        onClick={ () => {
          window.open('https://spotlight.soy/detail?article_id=ckkgeevvg');
        } }>
        {words.guideline[state.language]}
      </button>
    </div>
  );
}

// ITEM
function Item(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );
  const item = props.item;
  const stateSetterForChange = props.stateSetterForChange;
  const addressMain = state.gallery.addressMain;

  // 場所入替矢印

  const arrowLeft =
  <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large borderNone cursor borderRadiusCircle turnPink '
    onClick={ (e) => {
      if (
        state.editNote.maybeNotSaved[addressMain] === undefined ||
        Object.values(state.editNote.maybeNotSaved[addressMain]).includes(true) === false
      ) {
        e.stopPropagation();
        dispatch({ type: 'itemReplace', index: props.index, direction: 'left' });
        stateSetterForChange(true);
      }
      else {
        dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseSaveYourDraftBeforeReplacing[state.language] });
      }
    }}
  >
    <img className='size2x2' src={iconCircleLeft} alt='' />
  </button>;

  const arrowRight =
  <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large borderNone cursor borderRadiusCircle turnPink '
    onClick={ (e) => {
      if (
        state.editNote.maybeNotSaved[addressMain] === undefined ||
        Object.values(state.editNote.maybeNotSaved[addressMain]).includes(true) === false
      ) {
        e.stopPropagation();
        dispatch({ type: 'itemReplace', index: props.index, direction: 'right' });
        stateSetterForChange(true);
      }
      else {
        dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseSaveYourDraftBeforeReplacing[state.language] });
      }
    }}
  >
    <img className='size2x2' src={iconCircleRight} alt='' />
  </button>;

  // コントロールセクション

  let controlSection;

  if (
    state.screen === 'gallery' &&
    state.session[state.gallery.addressMain] !== undefined &&
    state.session[state.gallery.addressMain].expirationOfSession > Date.now() + marginOfSessionTime &&
    state.editNote.publicationType === 'draft'
  ) {
    controlSection =
    <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax ' >
      { arrowLeft }
      { arrowRight }
    </div>;
  }

  let supply;

  if (state.assetInfo[item.asset] !== undefined) {
    supply = state.assetInfo[item.asset].supply;
  }
  else {
    supply = null;
  }

  let lockedImage;

  if (state.assetInfo[item.asset] !== undefined && state.assetInfo[item.asset].locked) {
    lockedImage = <img className='size1p7x1p7' src={iconLock} alt='' />;
  }
  else {
    lockedImage = null;
  }

  let screen;
  let soldOut;

  if (item.status === 'soldOut') {
    screen = <div className='screen140'>
    </div>;

    soldOut = <div className='z150Center soldOut'>
      SOLD OUT
    </div>;
  }
  else {
    screen = null;
    soldOut = null;
  }

  // 保有数
  let balance;
  let balanceNum = 0;

  for (const address of Object.keys(state.session)) {
    if (state.session[address].expirationOfSession >= Date.now()) {
      balanceNum += state.balance.monaparty[address]?.[item.asset]?.quantity || 0;
    }
  }

  if (Object.keys(state.session).length > 0) {
    balance = <div className='z170TopRight flexRow justifyContentCenter alignItemsCenter size2x2Large borderRadius0p5 backgroundColorMonacottoAlmostWhiteBf ' >
      { balanceNum }
    </div>
  }
  else {
    balance = null;
  }

  if (state.balanceFilter === true && balanceNum > 0) {
    return null;
  }

  // モナダム登録有無
  let monadomCard;

  if (state.registeredCard[item.asset] !== undefined) {
    monadomCard =
    <div className='borderMonacotto padding0p3 marginTopBottom0p5'>
      { 'MONADOM' }
    </div>;
  }


  return (
    <div className='flexColumn alignItemsCenter ' >
      { controlSection }
      <button className='boxCard' disabled={props.disabled ? true : false}
        onClick={ () => {
          dispatch({ type: 'setStateMultiLayers', keys: ['itemDetail', 'item'], value: props.item });
          dispatch({ type: 'setStateMultiLayers', keys: ['itemDetail', 'exhibitor'], value: props.exhibitor});
          navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/item' : '/item');
        }}
      >
        <div className='flexColumn justifyContentFlexStart'>
          <div className='relative' >
            {
              state.monacard[props.item.asset] !== undefined ?
              <img className='cardImage' src={state.config.clientParameters.monacardUrl + state.monacard[item.asset].cid + 'l'} alt='' />
              : null
            }
            { screen }
            { soldOut }
            { balance }
          </div>
          <div className='flexRow justifyContentFlexStart font1p5 '>
            {item.asset_longname === null ? item.asset : item.asset_longname}
          </div>
          <div className='flexRow justifyContentSpaceBetween '>
            <div className='flexRow alignItemsFlexEnd'>
              <span className='font1p5'>{item.priceMona}</span>
              <span className='paddingLeft0p5'>{'MONA'}</span>
            </div>
            <div className='flexRow alignItemsFlexEnd'>
              <span className='paddingRight0p5'>{words.amountToSell[state.language]}</span>
              <span className='font1p5'>{`${item.amountFree} / ${supply}`}</span>
              { lockedImage }
            </div>
          </div>
          { monadomCard }
        </div>
      </button>
    </div>
  );
}

export {
  Header,
  Notification,
  NotificationFadingOut,
  RollingCottochan,
  AddressSection,
  AddressHistoryPopup,
  UserName,
  ForDevelopment,
  Footer,
  Item,
};
